/**
 * @generated SignedSource<<6bb3f5d7c6d8a3f8b3424f6e85016e58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespRelatedItem_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_viewer">;
  readonly " $fragmentType": "SharedRespRelatedItem_viewer";
};
export type SharedRespRelatedItem_viewer$key = {
  readonly " $data"?: SharedRespRelatedItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespRelatedItem_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7184f83bb6d48515faac5faf0c74b632";

export default node;
